import { normalizeCurrency } from "./normalizeCurrency";

export const calcularIcms = (
    freteFiscal: number | string,
    taxaIcms: number,
): string => {
    let freteFiscalValue: number = 0;

    if (typeof freteFiscal === "string") {
        freteFiscal = freteFiscal.replace(/\./g, "").replace(",", ".");
        freteFiscalValue = parseFloat(freteFiscal) || 0;
    } else if (typeof freteFiscal === "number") {
        freteFiscalValue = freteFiscal;
    }

    const taxaCalculada = normalizeCurrency(((freteFiscalValue / (1 - taxaIcms) - freteFiscalValue).toFixed(2).toString().replace(".", ",")));

    if (!taxaCalculada || isNaN(parseFloat(taxaCalculada))) {
        return "0,00";
    }

    return taxaCalculada;
};